import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';

@Injectable({
  providedIn: 'root'
})
export class ConsultationService {
  searchPath = ServicePathsSettings.URL_GET_CONSULTATION;

  constructor(private http: HttpClient) { }

  searchConsultation(searchRequest): Observable<any> {

    return this.http.post<any>(this.searchPath, searchRequest);
  }

  //anon

  anonSearchByRole(searchRequest): Observable<any> {
    return this.http.post<any>(
      ServicePathsSettings.URL_PDA_ANON_SEARCH_BY_ROLE,
      searchRequest
    );
  }

  anonSearchByRoleCass(searchRequest): Observable<any> {
    return this.http.post<any>(
      ServicePathsSettings.URL_PDA_ANON_SEARCH_BY_ROLE_CASS,
      searchRequest
    );
  }

  anonSearchByDate(searchRequest): Observable<any> {
    return this.http.post<any>(
      ServicePathsSettings.URL_PDA_ANON_SEARCH_BY_DATE,
      searchRequest
    );
  }

}
